import React from 'react';

import { AppLoadingScreen } from './helpers';
import { useAuthRedirect } from './hooks';

interface Auth0Props {}

const Auth0 = (props: Auth0Props) => {
  useAuthRedirect();

  return <AppLoadingScreen />;
};

export default Auth0;
